import { DropdownMenu, DropdownSelectTrigger } from '@hotjar/hotsauce';
import type { BasicListOption } from '../GenericLargeListFilter/GenericLargeListType';
import type { InfoFooter } from './GenericFilterSelectType';

interface GenericFilterSelectProps<T> {
  value?: T;
  onChange: (newValue: T) => void;
  optionList: BasicListOption<T>[];
  isInvalid?: boolean;
  size?: 's' | 'm' | 'l';
  infoFooter?: InfoFooter;
}

export const GenericFilterSelect = <T extends string>({
  value,
  onChange,
  optionList,
  isInvalid,
  size,
  infoFooter,
}: GenericFilterSelectProps<T>): JSX.Element => {
  const dropdownItemsList = infoFooter ? [...optionList, infoFooter] : optionList;

  return (
    <DropdownMenu
      trigger={
        <DropdownSelectTrigger
          size={size}
          selectedOption={optionList.find((item) => item.value === value)}
          isInvalid={isInvalid}
        />
      }
      size="m"
      appendTo="parent"
      onShow={({ popper, reference }) => {
        if (!infoFooter) {
          // We overidde the width to match the length of the trigger element
          // eslint-disable-next-line no-param-reassign
          (popper.firstChild as HTMLElement).style.width = `${
            reference.getBoundingClientRect().width
          }px`;
        } else {
          (popper.firstChild as HTMLElement).style.removeProperty('width');
        }
      }}
    >
      {dropdownItemsList.map((item) =>
        'link' in item ? (
          <DropdownMenu.LinkItem key={item.link} hasDivider href={item.link} isExternal icon="info">
            {item.label}
          </DropdownMenu.LinkItem>
        ) : (
          <DropdownMenu.Item
            key={item.value}
            onClick={() => onChange(item.value)}
            isSelected={item.value === value}
          >
            {item.label}
          </DropdownMenu.Item>
        ),
      )}
    </DropdownMenu>
  );
};
